import { ChakraProvider } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import ProductDetail from "./pages/ProductDetail";
import Login from "./pages/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminHeroSlides from "./pages/admin/AdminHeroSlides";
import AdminFeaturedCarousels from "./pages/admin/AdminFeaturedCarousels";
import theme from "./theme";

const SiteChrome = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isBackOffice =
    location.pathname.startsWith("/admin") || location.pathname === "/login";

  return (
    <>
      {!isBackOffice && <Navbar />}
      {children}
      {!isBackOffice && <Footer />}
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <ChakraProvider theme={theme}>
        <Router>
          <SiteChrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/category/:categorySlug"
                element={<CategoryPage />}
              />
              <Route
                path="/category/:categorySlug/:subcategorySlug"
                element={<CategoryPage />}
              />
              <Route path="/product/:productId" element={<ProductDetail />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminProducts />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="hero-slides" element={<AdminHeroSlides />} />
                <Route
                  path="featured-carousels"
                  element={<AdminFeaturedCarousels />}
                />
              </Route>
            </Routes>
          </SiteChrome>
        </Router>
      </ChakraProvider>
    </HelmetProvider>
  );
}

export default App;
